const getDefaultState = () => {
    return {
        primaryColor: '#1398b5',
        titlesColor: '#000000',
        fieldsColor: '#787d8f',
        backGroundColor: 'rgba(245, 245, 245, 1)',
        fontFamily: 'Roboto, sans-serif'
    }
}

const webFormStyle = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setFontFamily(state, value) {
            state.fontFamily = value
        },
        setPrimaryColor(state, value) {
            state.primaryColor = value
        },
        setTitlesColor(state, value) {
            state.titlesColor = value
        },
        setFieldsColor(state, value) {
            state.fieldsColor = value
        },
        setBackGroundColor(state, value) {
            state.backGroundColor = value
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default webFormStyle